export default __webpack_public_path__ + "static/media/JS.6a9976d8.png";